import * as React from 'react';
import {StyleProp, TextStyle, ViewStyle} from 'react-native';

import BaseButton, {FontSizeClass} from './BaseButton';

interface Props {
  style?: StyleProp<ViewStyle>;
  fontStyle?: StyleProp<TextStyle>;
  buttonSize?: {width: number; height: number};
  fontSizeClass?: FontSizeClass;
  disabled?: boolean;
  unwrappedText?: boolean;
  children?: React.ReactNode;
  onPress: () => void;
}

const PrimaryButton: React.FunctionComponent<Props> = props => {
  const {
    style,
    fontStyle,
    buttonSize,
    fontSizeClass,
    disabled,
    unwrappedText,
    children,
    onPress,
  } = props;
  return (
    <BaseButton
      style={style}
      fontStyle={fontStyle}
      tintColor={'orange'}
      buttonSize={buttonSize || DEFAULT_BUTTON_SIZE}
      fontSizeClass={fontSizeClass}
      disabled={disabled}
      unwrappedText={unwrappedText}
      onPress={onPress}>
      {children}
    </BaseButton>
  );
};

export default React.memo(PrimaryButton);

const DEFAULT_BUTTON_SIZE = {
  width: 311,
  height: 46,
};
